import Request, { SimpleResponse } from './Request';

export interface ISales {
    id: number;
    groupId: number;
    groupName: string;
    groupCode: string;
    groupParentId: number;

    channels: IChannel[];
    children: ISales[];
}

export interface IChannel {
    channelId: number;
    channelName: string;
    channelOrder: number;

    id: number;
    tradeSalesActual: number;
    currentDate: Date;
    previousTradeSalesActual: number;
    previousDate: Date;
    tradeSalesBusinessPlan: number;
    tradeSalesFRE: number;
    tradeSalesSRE: number;
    tradeSalesLE: number;
    tradeSalesOP: number;

    isSales: boolean;
}

class Group {
    static GetAll = (year: Number, month: Number): ISales[] => { return Request.DoGet('sales/all/' + year + '/' + month) as unknown as ISales[]; };
    static Get = (group: Number, year: Number, month: Number): ISales => { return Request.DoGet('sales/' + group + '/' + year + '/' + month) as unknown as ISales; };
    static Update = (id: Number, data: ISales): SimpleResponse => { return Request.DoPut('sales/' + id, data) as unknown as SimpleResponse; };
    static Create = (year: Number, month: Number, data: ISales): SimpleResponse => { return Request.DoPost('sales/' + year + '/' + month, data) as unknown as SimpleResponse; };
}

export default Group;